import { X } from 'lucide-react';
import { Button } from '#client/components/ui/Button';
import { TextField } from '#client/components/ui/TextField';
import type { Repeater } from '#client/hooks/useRepeater';
import type { ResultRow } from './parameter-form.logic';

interface ParameterResultFieldsProps {
  results: Repeater<ResultRow>;
  errors: Record<string, string>;
}

/**
 * Preset results a technician picks from instead of typing — "Positive",
 * "Negative", "Not detected".
 *
 * Deliberately not the bordered fieldset the ranges use: a single-field row is
 * lighter than a cohort, and giving it a legend and a border would make the
 * two read as equally weighty.
 */
export function ParameterResultFields({ results, errors }: ParameterResultFieldsProps) {
  if (results.rows.length === 0) {
    return (
      <p className="text-fg-muted">
        Optional. Add preset results such as “Positive” or “Negative” for this parameter.
      </p>
    );
  }

  return (
    <div className="c-field-rows">
      {results.rows.map((result, index) => (
        <div className="c-field-row" key={results.keys[index]}>
          <TextField
            className="c-field-row__control"
            label={`Result ${index + 1}`}
            value={result.value}
            error={errors[`results.${index}.value`]}
            onChange={(event) => results.update(index, { value: event.target.value })}
          />
          <Button
            variant="ghost"
            icon={<X />}
            aria-label={`Remove result ${index + 1}`}
            onClick={() => results.remove(index)}
          />
        </div>
      ))}
    </div>
  );
}
